import { UpdateOfflineInvestorAction } from 'src/actions/project/offline-investor/update/UpdateOfflineInvestor.actions';
import * as UpdateOfflineInvestorTypes from 'src/actions/project/offline-investor/update/Types';

export interface UpdateOfflineInvestorState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: UpdateOfflineInvestorState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function UpdateOfflineInvestorReducer(state: UpdateOfflineInvestorState = initialState,
                                             action: UpdateOfflineInvestorAction): UpdateOfflineInvestorState {
  switch (action.type) {
    case UpdateOfflineInvestorTypes.UPDATE_OFFLINE_INVESTOR_ATTEMPT:
      return {...state, loading: true, error: false};
    case UpdateOfflineInvestorTypes.UPDATE_OFFLINE_INVESTOR_SUCCESS:
      return {...state, loading: false, error: false};
    case UpdateOfflineInvestorTypes.UPDATE_OFFLINE_INVESTOR_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/project/offline-investor/UpdateOfflineInvestorReducer.tsx